import React, {useState, useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Col, Row, Card, Form} from "react-bootstrap";
import Logo from "../assets/images/logo.svg"
import Client from "../assets/images/school_svgrepo.com_1.svg"
import {getUserAccessLevel} from "../actions/LoginActions";
import Loader from "../components/Loader";
import AlertModal from "../components/AlertModal";
import LoginImage from "../components/LoginImage";
import {
    ACCESS_TOKEN,
    AUTH_EMPLOYEEID,
    AUTH_IS_TRAINING_ENABLE,
    AUTH_USERNAME,
    INITIAL_TOKEN,
    INITIAL_TOKEN_STAGE_CLIENT
} from "../constants";
import useAuthPublicPagesRedirect from "../hooks/auth/useAuthPublicPagesRedirect";
import {jwtDecode} from "jwt-decode";

function SelectClient() {
    const dispatch = useDispatch();
    const [client, setClient] = useState();
    const [alertModal, setAlertModal] = useState({
        display: false,
        type: "",
        message: ""
    })

    const getUserAccessLevelDetails = useSelector(state => state.getUserAccessLevel)
    const {loading} = getUserAccessLevelDetails

    useAuthPublicPagesRedirect(INITIAL_TOKEN_STAGE_CLIENT);

    useEffect(() => {
        if (getUserAccessLevelDetails.userInfo === true) {
            if (getUserAccessLevelDetails?.result?.token !== null) {
                const decoded = jwtDecode(getUserAccessLevelDetails.result.token);

                localStorage.removeItem(INITIAL_TOKEN);
                localStorage.setItem(AUTH_USERNAME, decoded?.UserName)
                localStorage.setItem(AUTH_EMPLOYEEID, decoded?.UserId)
                localStorage.setItem(ACCESS_TOKEN, JSON.stringify(getUserAccessLevelDetails.result.token))
                localStorage.setItem(AUTH_IS_TRAINING_ENABLE, decoded.IsTrainingEnable);

                window.location.href = "/";
            }

            if (getUserAccessLevelDetails?.result?.token === null) {
                setAlertModal({
                    display: true,
                    type: "error",
                    message: "Client could not be selected at the moment"
                })
            }
        }
        if (getUserAccessLevelDetails.error) {
            setAlertModal({
                display: true,
                type: "error",
                message: "Client could not be selected at the moment"
            })
        }
    }, [getUserAccessLevelDetails.userInfo]);

    const changeStyle = (data) => {
        setClient(data);
    };

    const showContacts = (data) => {
        if (data !== null)
            return data.map((item) => {
                try {
                    return (
                        <div className="col-lg-4 col-md-6 client-div">
                            <Form.Check
                                reverse
                                name="client"
                                label=<img src={Client} alt="client" className="centered-image"/>
                            type="radio"
                            id={item.id}
                            key={item.id}
                            onClick={() => changeStyle([item.id, item.name])}
                            />
                            <p className="message-5">{item.name}</p>
                        </div>
                    )
                } catch (e) {
                    alert(e.message);
                }
            });
    }

    const submitHandler = (event) => {
        event.preventDefault();
        window.scrollTo(0, 0)
        localStorage.setItem('client_id', client[0])
        localStorage.setItem('client_name', client[1])
        dispatch(getUserAccessLevel(client[0]));
    };

    const closeAlert = () => {
        setAlertModal({
            display: false
        })
    }

    return (
        <Row className="login-background">
            {alertModal.display &&
                <AlertModal heading={alertModal.message} type={alertModal.type} result={closeAlert}/>}
            {loading && <Loader/>}
            <Col lg={{span: 4, offset: 1}} md={{span: 5, offset: 1}}>
                <Card className="card-body">
                    <img src={Logo} alt="logo" className="logo"/>
                    <form className="margin-top">
                        <p className="header">Select Client</p>
                        <p className="sub-header">Please select which Client you are accessing</p>
                        <div className="row background-1">
                            {showContacts(JSON.parse(localStorage.getItem('clients')))}
                        </div>
                        <div className="login-button">
                            <button
                                onClick={submitHandler}
                                disabled={!client}
                                type="submit"
                                className={`button-solid ${!client ? "button-inactive" : "button-active"} `}
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                    <div className="copyright">
                        <p className="sub-footer">v2.0</p>
                        <p className="sub-footer">copyright text</p>
                    </div>
                </Card>
            </Col>
            <Col lg={{span: 7, offset: 0}} md={{span: 5, offset: 0}}>
                <LoginImage/>
            </Col>
        </Row>
    );
}

export default SelectClient;